"use client";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import React from "react";

const privacyBreadcrumbPaths: BreadcrumbPath[] = [
    { label: "Home", route: "/" },
    { label: "Privacy Policy" },
];

const PrivacyPolicy = () => {
    return (
        <section
            id="main-section"
            className="md:px-auto mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:px-36 md:pb-[120px] md:pt-8"
        >
            <Breadcrumb paths={privacyBreadcrumbPaths} />
            <h2 id="heading" className="mb-4 text-4xl font-semibold md:mb-8 md:text-6xl">
                Privacy and Policy
            </h2>
            <p id="para1" className="mb-8 text-base text-neutral-500">
                Incredmoney.com or its iOS and android applications (&quot;Website&quot; or
                &quot;the Site&quot;), operated and owned by InCred Money and its subsidiaries
                (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, &quot;InCred Money&quot;,
                &quot;incredmoney&quot;), has adopted this policy with recognition that protecting
                the privacy and security of the personal information we obtain about our visitors
                and registered users is an important responsibility. We also know that you expect us
                to service you in an accurate and efficient manner. To do so, we must collect and
                maintain certain personal information about you. This policy outlines the types of
                information we collect about you and how we use and safeguard that information. By
                using or accessing the Site in any manner, you acknowledge that you accept the
                practices and policies outlined in this Privacy Policy, and you hereby consent that
                we will collect, use, and share your information in the following ways.
            </p>
            <p id="para2" className="mb-8 text-base text-neutral-500">
                If you do not agree with the Terms and Conditions of this policy, please do not
                proceed or continue further to use this website.
            </p>
            <p className="mb-4 text-lg font-semibold text-neutral-500">Definitions</p>
            <div id="div1" className="mb-8 text-base text-neutral-500">
                <p className="mb-2">
                    <span className="font-semibold">
                        &quot;User&quot;,&quot;You&quot;,&quot;Your&quot;,&quot;your&quot;
                    </span>{" "}
                    means any person or visitor or registered user who views, browses, accesses or
                    uses the Site.
                </p>
                <p className="mb-2">
                    <span className="font-semibold">&quot;Use&quot; or &quot;Using&quot;</span>{" "}
                    means to browse, access, view, copy, availing Services or other benefit from
                    using the Site.
                </p>
                <p className="mb-2">
                    <span className="font-semibold">&quot;Policy&quot;</span> means this Privacy
                    Policy.
                </p>
                <p className="mb-2">
                    <span className="font-semibold">&quot;Services&quot;</span> means all the
                    services as provided in Terms & Conditions from time to time.
                </p>
                <p className="mb-2">
                    <span className="font-semibold">&quot;Registered User&quot;</span> shall mean
                    and include the visitors who have an Investment Account with the Site to avail
                    the Services or any part thereof, as provided on the Site.
                </p>
            </div>

            <p className="mb-4 text-lg font-semibold text-neutral-500">
                What information we collect any why
            </p>
            <div id="div2" className="mb-8 text-base text-neutral-500">
                <p className="mb-2">
                    We collect two types of information from our registered users and visitors.
                </p>
                <p className="mb-2">
                    We collect two types of information from our registered users and visitors. The
                    first is information that we gather through aggregated tracking information
                    derived about our users through the website. Anonymous information and
                    statistics are compiled or system log files to allow us to better tailor our
                    services to our needs, help us better understand the demographics of our
                    audience and improve our products.
                </p>
                <p className="mb-2">
                    The second is information that registered users provide through optional,
                    voluntary submissions such as:
                </p>
                <ol className="mb-4 ml-6 list-decimal">
                    <li className="mb-1">
                        Name and Contact Information, including email address, third party account
                        credentials etc.
                    </li>
                    <li className="mb-1">
                        Personal Information, including date of birth and Permanent Account Number
                        (PAN) and other information required in accordance with the KYC norms and
                        regulatory requirements.
                    </li>
                    <li className="mb-1">Demographic Information such as gender and income.</li>
                    <li className="mb-1">
                        Other information that can help us improve our services.
                    </li>
                </ol>
            </div>

            <p className="mb-4 text-lg font-semibold text-neutral-500">
                We require this information
            </p>
            <div id="div3" className="mb-8 text-base text-neutral-500">
                <ol className="mb-4 ml-6 list-decimal">
                    <li className="mb-1">
                        To perform compliance checks and internal record keeping.
                    </li>
                    <li className="mb-1">
                        To use the information to improve our products and services.
                    </li>
                    <li className="mb-1">
                        To periodically send emails to your registered email address about new
                        products, special offers, or other information which we think you may find
                        interesting.
                    </li>
                    <li className="mb-1">
                        You are free to unsubscribe your email address at any time, if you do not
                        wish to receive such emails from us.
                    </li>
                    <li className="mb-1">
                        From time to time, we may also use your information to contact you via phone
                        or email for market research purposes.
                    </li>
                </ol>
                <p className="mb-2">
                    Also, we may review a confirmation when you open an email from us. This will
                    help us make our communications with you more interesting.
                </p>
                <p className="mb-2">
                    We need physical evidence of your personal details like PAN, cancelled cheque
                    etc. to satisfy regulatory requirements while your bank details are required to
                    honour your investment instructions.
                </p>
                <p className="mb-2">
                    InCred Money shall not be responsible, in the event, any discrepancy is found,
                    in any of the information provided by the user, such as, mismatch of the
                    information provided, shall lead to the rejection for opening of the account.
                </p>
                <p className="mb-2">
                    We may also ask for additional personal information from time to time to meet
                    new regulatory requirements or to provide you with other benefits of our
                    services. As always, the information that we seek will only be for the purpose
                    stated.
                </p>
                <p className="mb-2">
                    You agree that all intellectual property including but not limited to copy
                    right, trade mark, any personal information, content, photographs, images,
                    experience sharing, feedback, opinions that is voluntarily shared by you with us
                    or uploaded on the Site are not infringing of any rights of third parties in
                    whatsoever manner and you give us unrestricted, perpetual right of use of your
                    such intellectual property for any purpose whatsoever.
                </p>
            </div>

            <p className="mb-4 text-lg font-semibold text-neutral-500">
                What information do we disclose
            </p>
            <div id="div4" className="mb-8 text-base text-neutral-500">
                <p className="mb-2">
                    We will not disclose the non-public personal information we collect about our
                    registered users to anyone except:
                </p>
                <ol className="mb-4 ml-6 list-decimal">
                    <li className="mb-1">
                        To perform accounting or compliance with industry standards (e.g.
                        professional licensing bodies, etc.).
                    </li>
                    <li className="mb-1">
                        Our Information, account numbers, and balances, or as otherwise required by
                        government agencies and other third parties by law.
                    </li>
                    <li className="mb-1">
                        Authorized third party service providers, entities or third parties with
                        whom we have tie-ups or service providers that help us with various products
                        and services offered on our platform, including financial pursuits, billing,
                        payment processing, customer service, email deployment, business analytics,
                        marketing, advertising, performance monitoring, hosting, and data
                        processing.
                    </li>
                    <li className="mb-1">
                        Corporate affiliates. We may share your information with our corporate
                        affiliates and group companies that are subject to this policy.
                    </li>
                    <li className="mb-1">
                        With your consent or at your direction. We may share information for any
                        other purposes disclosed to you at the time we collect the information or
                        pursuant to your consent or direction.
                    </li>
                    <li className="mb-1">
                        In Business transfers. If we choose to buy or sell assets. In these types of
                        transactions, customer information is typically one of the business assets
                        that would be transferred. Also, if we (or our assets) are acquired, or if
                        we go out of business, enter bankruptcy, or go through some other change of
                        control, Personal Information could be one of the assets transferred to or
                        acquired by a third party.
                    </li>
                    <li className="mb-1">
                        We transfer/share Your information with our service professionals, group
                        companies or business partners to facilitate the availing/provision of
                        Services by You.
                    </li>
                </ol>
            </div>

            <p className="mb-4 text-lg font-semibold text-neutral-500">
                Security of your information
            </p>
            <div id="div5" className="mb-8 text-base text-neutral-500">
                <p className="mb-2">
                    We are committed to ensuring that your information is secure. In order to
                    prevent unauthorized access or disclosure, we have put in place suitable
                    physical, electronic and managerial procedures to safeguard and secure the
                    information we collect online. See more on our Security Features. We restrict
                    access to your personal information between our servers and the Internet so
                    there is no clear text transmission of such information.
                </p>
                <p className="mb-2">
                    However no method of transmission over the internet, or method of electronic
                    storage is 100% secure. We strive to use commercially acceptable means to
                    protect your personal information, we cannot guarantee its absolute security. In
                    addition, hardware or software failures or other factors, may compromise the
                    security of user information at any time. If you think that the security of your
                    InCred Money account has been compromised, change your password and contact us
                    immediately for further assistance.
                </p>
            </div>

            <p
                id="Data-Retention-and-Deletion"
                className="mb-4 text-lg font-semibold text-neutral-500"
            >
                Data Retention and Deletion
            </p>
            <div className="mb-8 text-base text-neutral-500">
                <p className="mb-2">
                    Retention of information collected: The information collected from you will be
                    retained during the (i) validity of your Account and for the purpose of
                    submission of such information, (ii) As consented by you while creating your
                    user Account (iii) As required by any regulatory norms.
                </p>
                <p className="mb-2">
                    We at InCred Money, promise to protect your personal data from unauthorised
                    access, misuse, and disclosure using the right security measures based on the
                    type of data and how we are processing the same. We retain information about you
                    to provide a seamless experience, to contact you in case of support required and
                    about your account, to detect, mitigate, prevent, and investigate fraudulent or
                    illegal activities during the course of the services. We retain your data for as
                    long as necessary based on statutory requirements and to provide you with our
                    services. We may also retain and use your basic personal information inter alia
                    as name, contact number, transactional details and address details as necessary
                    to comply with our legal obligations, resolve disputes, send you notifications
                    and enforce our agreements which shall always be in accordance with applicable
                    laws.
                </p>
            </div>

            <p className="mb-4 text-lg font-semibold text-neutral-500">Communications</p>
            <ol className="mb-4 ml-6 list-decimal text-neutral-500">
                <li className="mb-1">
                    We will send registered users communications related to the servicing of your
                    account when necessary to do so.
                </li>
                <li className="mb-1">
                    We will send registered users service-related announcements on rare occasions
                    when it is necessary to do so. For instance, if our service is temporarily
                    suspended for maintenance, we might send you an email.
                </li>
                <li className="mb-1">
                    You may not opt-out of account servicing communications or service-related
                    announcements, which are not promotional in nature.
                </li>
                <li className="mb-1">
                    We will send registered users occasional emails updating you about new products,
                    special offers, or other information which we think you may find interesting.
                    You may unsubscribe from these at any time.
                </li>
            </ol>
            <p className="mb-8 text-neutral-500">
                All communications will be sent to the email id that you have provided us. It is
                your responsibility to update or change that address, as appropriate. If you haven’t
                provided us with your email address, you will not receive these communications.
            </p>

            <p className="mb-4 text-lg font-semibold text-neutral-500">Website usage</p>
            <ol className="mb-4 ml-6 list-decimal text-neutral-500">
                <li className="mb-1">
                    When you visit our website we use &quot;cookies&quot; or other similar web tools
                    to enhance the user experience. These tools enable us to maintain your web
                    session while you browse the site as well as helping us provide you with a
                    better, more personalized experience. Our cookies do not contain any personally
                    identifiable information. You may be able to change the preferences on your
                    browser or device to prevent or limit your device&rsquo;s acceptance of cookies,
                    but this may prevent you from taking advantage of some of our features.
                </li>
                <li className="mb-1">
                    InCred Money automatically receives and records information on our server logs
                    from your browser including your IP address, InCred Money cookie information and
                    the pages you request. We use this information to improve the functionality and
                    usability of our services. Our log files are not tied to personally identifiable
                    information.
                </li>
                <li className="mb-1">
                    Our advertising partners may also transmit cookies to your browser or device,
                    when you click on ads that appear on the Site.
                </li>
            </ol>
        </section>
    );
};

export default PrivacyPolicy;
